/**
 * Per-role PWA manifest helper.
 *
 * The app supports 4 install variants:
 *   - customer  → "iCaard"           opens at /app
 *   - merchant  → "iCaard Merchant"  opens at /app/merchant
 *   - organizer → "iCaard Organizer" opens at /app/organizer
 *   - staff     → "iCaard Staff"     opens at /app/scan
 *
 * PWA install prompts read the manifest *at install time*. So when a user
 * scans a role-specific activation QR, we swap the <link rel="manifest"> tag
 * BEFORE the install prompt fires. After install, the home-screen icon name
 * is fixed and cannot be edited by the user (icon name comes from manifest.name).
 */

const ROLE_MANIFEST = {
  customer: "/manifest-customer.webmanifest",
  merchant: "/manifest-merchant.webmanifest",
  organizer: "/manifest-organizer.webmanifest",
  staff: "/manifest-staff.webmanifest",
};

export function setManifestForRole(role) {
  if (!role || !ROLE_MANIFEST[role]) return;
  try {
    // Persist so re-loads (and the install prompt event) still pick the right variant.
    localStorage.setItem("icard_install_role", role);
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "manifest";
      document.head.appendChild(link);
    }
    link.href = ROLE_MANIFEST[role];
  } catch (e) {
    // No-op; manifest swap is best-effort.
  }
}

export function getInstallRole() {
  try {
    return localStorage.getItem("icard_install_role") || "customer";
  } catch (e) {
    return "customer";
  }
}

// On every app boot, restore the previously-chosen manifest variant.
export function bootManifestFromStorage() {
  const role = getInstallRole();
  setManifestForRole(role);
}
